import { openInNewTab } from "@/utils/open-in-new-tab";
import { logUserAction } from "@/apis/logs/route";
import { DsdFile } from "@/types/dsd";
import { DsdComparePage } from "@/components/team-workspace/dsds-compare";
import { LeftSidebar } from "@/components/app-shell";
import { useState } from "react";

// ── Upload View (MainContent) ──

const MainContent = () => {
  const [baseFile, setBaseFile] = useState<DsdFile | null>(null);
  const [compareFile, setCompareFile] = useState<DsdFile | null>(null);

  const handleCompare = () => {
    if (!baseFile || !compareFile) return;
    logUserAction("DSD 보고서 대사", [
      { filename: baseFile.name, dsdFileId: baseFile.id },
      { filename: compareFile.name, dsdFileId: compareFile.id },
    ]);
    openInNewTab(
      `/compare/dsd-dsd/result?src=${baseFile.id}&trg=${compareFile.id}`,
    );
  };

  return (
    <div className="flex flex-1 h-full flex-col items-center self-stretch overflow-y-auto relative">
      <DsdComparePage
        baseFile={baseFile}
        compareFile={compareFile}
        onSelectBaseFile={setBaseFile}
        onSelectCompareFile={setCompareFile}
        onCompare={handleCompare}
      />
    </div>
  );
};

// ── Workspaces ──

const DSDCompareWorkspace = () => (
  <div className="inline-flex w-full h-full items-center relative">
    <LeftSidebar activeMenu="compare" />
    <MainContent />
  </div>
);

export default DSDCompareWorkspace;
